module.exports = __webpack_public_path__ + "static/media/carved.f582be03.webp";